/* eslint-disable no-console */
import React from 'react';
import { RACCard, RACButton } from '@rentacenter/racstrap';
import clsx from 'clsx';
import { customerStyles } from '../customerStyles';

interface FooterProps {
  handleSubmit: () => void;
  name: string;
}

const Footer: React.FC<FooterProps> = ({ handleSubmit, name }) => {
  const classes = customerStyles();

  return (
    <div className={clsx(classes.footerRoot)}>
      <RACCard className={classes.footerCard}>
        <div className={clsx(classes.footerCardBody)}>
          <div className={clsx(classes.row)}>
            <div className={classes.footerRightButtonsContainer}>
              <RACButton
                className={clsx(classes.footerButton)}
                variant="contained"
                size="small"
                color="primary"
                onClick={handleSubmit}
              >
                {name}
              </RACButton>
            </div>
          </div>
        </div>
      </RACCard>
    </div>
  );
};

export default Footer;
